import {Catalog} from '../../common/types/common';
import {DisplaySummaryDTO} from '../types/mx/creditoReal/epics';

export const EMPTY_STRING: string = '';
export const EMPTY_NUMBER: number = 0;
export const EMPTY_CATALOG: Catalog = {id: '', value: '', payload: ''} as Catalog;
export const EMPTY_DISPLAY_VALUE: DisplaySummaryDTO = {value: 0, displayValue: ''} as DisplaySummaryDTO;
export const TABLET: string = 'Tablet';
export const PHONE: string = 'Phone';
export const DESKTOP: string = 'Desktop';
export const APP_MOBILE: string = 'mobile';
export const APP_WEB: string = 'web';
export const ACTIVE_KEY_1: string = 'activeKey1';
export const ACTIVE_KEY_2: string = 'activeKey2';
export const ACTIVE_KEY_3: string = 'activeKey3';
export const ACTIVE_KEY_4: string = 'activeKey4';